module.exports = __webpack_public_path__ + "static/media/over_capacity.08ff379b.svg";